// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"a8237c23","977":"7611ce27"}[chunkId] + ".chunk.js";
};